import { buildLocalizedPath, stripLocalePrefix } from '~/utils/buildLocalizedPath';
import {
  ALL_LOCALE_CODES,
  getFallbackLocale,
  isLocaleExcluded,
  parseExcludedLocales,
} from '~/utils/excludedLocales';


export default defineNuxtRouteMiddleware((to) => {
  const excludedLocales = parseExcludedLocales(useRuntimeConfig().public.excludedLocales);

  if (excludedLocales.length === 0) {
    return;
  }

  const currentLocale = (to.path.split('/')[1] || 'en').toLowerCase();

  if (!isLocaleExcluded(currentLocale, excludedLocales)) {
    return;
  }

  const fallbackLocale = getFallbackLocale(excludedLocales);
  const destination = buildLocalizedPath(
    stripLocalePrefix(to.fullPath, ALL_LOCALE_CODES),
    fallbackLocale,
  );

  if (destination === to.fullPath) {
    return;
  }

  const localeCookie = useCookie('i18n_redirected', {
    path: '/',
    sameSite: 'lax',
  });

  localeCookie.value = fallbackLocale;

  return navigateTo(destination, { replace: true });
});
